import { connect } from 'react-redux';
import Sandbox from './pure';
import { fetchData, getByKey } from '../fetchActions';

const mapStateToProps = (state, ownProps) => ({
  show: state.sidebar.show,
  homepage: getByKey('homepage', state)
})

const mapDispatchToProps = (dispatch) => ({
  onToggleHamburger: () => dispatch({type: 'TOGGLE_SIDEBAR_SHOW'}),
  closeSidebar: () => dispatch({type: 'CLOSE_SIDEBAR_SHOW'}),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sandbox);



// WEBPACK FOOTER //
// ./src/components/Sidebar/connected.js